export const PricingTierHeader: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <div className='text-lg font-semibold'>{children}</div>;
};
